import { View } from 'react-native'
import { ConfigurablePromo } from './ConfigurablePromo'

const empty = []

export const ConfigurablePromos = ({ promos = empty, ...promoProps }) => {
  return !promos?.length ? null : (
    <View>
      {promos.map((config) => (
        <ConfigurablePromo key={config.title} {...promoProps} {...config} />
      ))}
    </View>
  )
}
